import { render, staticRenderFns } from "./ModeratorEfficencyCell.vue?vue&type=template&id=4b71e8ac&"
import script from "./ModeratorEfficencyCell.vue?vue&type=script&lang=babel&"
export * from "./ModeratorEfficencyCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports